<template>
  <div v-if="content" v-editable="content" id="conseils">
    <component :content="blok" :key="blok._uid" v-for="blok in content.body" :is="blok.component"></component>
  </div>
</template>

<script>
import api from "@/api";

export default {
  data() {
    return {
      content: null
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      const res = await api.get(
        `cdn/stories/${this.$i18n.locale}/pages/conseils-malins`
      );
      this.content = res.data.story.content;
    }
  }
};
</script>

<style lang="scss">

</style>
